import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useState , useEffect } from 'react';
import { useDispatch , useSelector } from 'react-redux';

function ForgotPassword({email , setEmail ,handleSendOtp, open, handleClose , otpSent , otp , setOtp , verifyOtp}) {
  console.log(email , "email")
  const sendOtp = ()=>{
    if(!email){
      alert("Please Enter email");
      return
    }
    handleSendOtp(email);
  }

  const verify = ()=>{
    if(!otp){
      alert("Please Enter otp");
      return
    }
    verifyOtp(email);
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            handleClose();
          },
          sx: { backgroundImage: 'none' },
        },
      }}
    >
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <DialogContentText>
          Enter your account&apos;s email address, and we&apos;ll send you a link to
          reset your password.
        </DialogContentText>
        
        <OutlinedInput
          autoFocus
          required
          margin="dense"
          id="email"
          name="email"
          label="Email address"
          placeholder="Email address"
          type="email"
          onChange={(e)=>setEmail(e.target.value)}
          disabled={otpSent}
          fullWidth
        />
        {otpSent && (
           <OutlinedInput
           autoFocus
           required
           margin="dense"
           id="OTP"
           name="otp"
           label="OTP"
           placeholder="Enter your OTP"
           type="email"
           fullWidth
           onChange={(e)=>setOtp(e.target.value)}
         />
        )}
        
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>Cancel</Button>
        {!otpSent && (
          <Button onClick={sendOtp} variant="contained">
            Send OTP
         </Button>
        )}
        
        {
          otpSent && (
            <Button onClick={verify} variant="contained">
              Verify
          </Button>
          )
        }
       
      </DialogActions>
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ForgotPassword;